import "../Components/Assets/CSS/Careers.css";
import Pilot from "../Components/Assets/Images/Pilot.jpg";
import Crew from "../Components/Assets/Images/cabinCrew.jpg";
import engg from "../Components/Assets/Images/engg.jpg";
import ops from "../Components/Assets/Images/ops.jpg";
import Finance from "../Components/Assets/Images/Finance.jpg";
import it from "../Components/Assets/Images/IT.jpg";
import career1 from "../Components/Assets/Images/career8.jpg";
import ResumeForm from "./ResumeForm";
import { useNavigate } from "react-router-dom";
import safty from "../Components/Assets/Images/Safety.jpg";
import reward from "../Components/Assets/Images/Reward.jpg";
import comunity from "../Components/Assets/Images/comminity.jpg";
import { Container, Row, Col } from "react-bootstrap";
import Card from "react-bootstrap/Card";
import CardGroup from "react-bootstrap/CardGroup";




const Careers = () => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/no-job-found");
  };

  return (
    <>
      <div className="position-relative career-cover ">
        <img src={career1} className="img-fluid w-100" alt="Career Banner" />

        <div
          className={`position-absolute top-50 start-50 translate-middle  
      }`}
        >
          <p className="lead"></p>
        </div>
      </div>

      <div className="containt-section">
        <h1>Join Our Journey</h1>
        <div className="carrier-text">
          At Shankh air we believe the sky is not the limit—it's just the
          beginning. We're more than an airline; we're a family of passionate
          professionals committed to delivering world-class service and
          redefining travel experiences.
        </div>
      </div>

      <div className="carrier-container">
        {/* <div className="apply-forjob">
          <Link to="/walk-in-jobs">Walk in-interview</Link>
        </div> */}
        <div className="department">
          <h1>Departments</h1>
        </div>
        <br></br>
        <div className="row row-cols-1 row-cols-md-3 g-5">
          <div className="col">
            <div className="card h-100 border-0 shadow-sm position-relative hover-card">
              <div className="overlay-text">Explore the World</div>
              <img src={Pilot} className="card-img-top" alt="Travel" />
              <div className="card-body">
                <h5 className="card-title">Pilots</h5>
                <p onClick={handleClick} className="card-text">
                  VIEW OPENING
                </p>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card h-100 border-0 shadow-sm position-relative hover-card">
              <div className="overlay-text">Explore the World</div>
              <img src={Crew} className="card-img-top" alt="Travel" />
              <div className="card-body">
                <h5 className="card-title">Cabin Crew</h5>
                <p onClick={handleClick} className="card-text">
                  VIEW OPENING
                </p>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card h-100 border-0 shadow-sm position-relative hover-card">
              <div className="overlay-text">Explore the World</div>
              <img src={engg} className="card-img-top" alt="Travel" />
              <div className="card-body">
                <h5 className="card-title">Engineering</h5>
                <p onClick={handleClick} className="card-text">
                  VIEW OPENING
                </p>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card h-100 border-0 shadow-sm position-relative hover-card">
              <div className="overlay-text">Explore the World</div>
              <img src={ops} className="card-img-top" alt="Travel" />
              <div className="card-body">
                <h5 className="card-title">Operation</h5>
                <p onClick={handleClick} className="card-text">
                  VIEW OPENING
                </p>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card h-100 border-0 shadow-sm position-relative hover-card">
              <div className="overlay-text">Explore the World</div>
              <img src={Finance} className="card-img-top" alt="Travel" />
              <div className="card-body">
                <h5 className="card-title">Finance</h5>
                <p onClick={handleClick} className="card-text">
                  VIEW OPENING
                </p>
              </div>
            </div>
          </div>

          <div className="col">
            <div className="card h-100 border-0 shadow-sm position-relative hover-card">
              <div className="overlay-text">Luxury in the Sky</div>
              <img src={it} className="card-img-top" alt="Luxury" />
              <div className="card-body">
                <h5 className="card-title">Information Technology</h5>
                <p onClick={handleClick} className="card-text">
                  VIEW OPENING
                </p>
              </div>
            </div>
          </div>

          {/* <div className="col">
            <div className="card h-100 border-0 shadow-sm position-relative hover-card">
              <div className="overlay-text">Sky's the Limit</div>
              <img src={hr} className="card-img-top" alt="Sky" />
              <div className="card-body">
                <h5 className="card-title">HR</h5>
                <p onClick={handleClick} className="card-text">
                  VIEW OPENING
                </p>
              </div>
            </div>
          </div> */}
        </div>
        <div className="below-textcareer">
          <h2>Ready to Take Off With Us?</h2>
          <p>
            If you're passionate about aviation and want to be part of something
            bigger, we want to hear from you. Send your resume to
            careers@shankhair.com
          </p>
          <div className="benifts-content" style={{ padding: "40px" }}>
            <h3 style={{ color: "gray" }}>Our employee focus areas.</h3>
          </div>
          <p>
            Whether you're at the start of your career or looking to take your
            professional life to new heights, Shankh Air offers an environment
            where you can truly thrive. Join a team that values passion, talent,
            and dedication in delivering exceptional services worldwide.
          </p>

          <CardGroup
            style={{
              padding: "20px",
              borderRadius: "10px",
              backgroundColor: "rgba(163, 163, 180, 0.1)",
            }}
          >
            <Card
              style={{ width: "18rem", margin: "10px", borderRadius: "50px" }}
            >
              <Card.Img
                style={{ borderRadius: "50px" }}
                variant="top"
                src={safty}
              />
              <Card.Body>
                <Card.Title style={{ fontSize: "35px" }}>
                  Safty & wellbeing
                </Card.Title>
                <Card.Text
                  style={{
                    backgroundColor: "white",
                    color: "gray",
                  }}
                >
                  Our top priority is ensuring the safety and wellbeing of all
                  individuals, fostering a healthy and secure environment.
                </Card.Text>
              </Card.Body>
            </Card>

            <Card
              style={{ width: "18rem", margin: "10px", borderRadius: "50px" }}
            >
              <Card.Img
                style={{ borderRadius: "50px" }}
                variant="top"
                src={reward}
              />
              <Card.Body>
                <Card.Title style={{ fontSize: "35px" }}>
                  Reward & recognition
                </Card.Title>
                <Card.Text style={{ backgroundColor: "white", color: "gray" }}>
                  We celebrate achievements and recognize hard work, offering
                  rewards that motivate and inspire individuals to reach their
                  full potential.
                </Card.Text>
              </Card.Body>
            </Card>

            <Card
              style={{ width: "18rem", margin: "10px", borderRadius: "50px" }}
            >
              <Card.Img
                style={{ borderRadius: "50px" }}
                variant="top"
                src={comunity}
              />
              <Card.Body>
                <Card.Title style={{ fontSize: "35px" }}>
                  Community responsibility
                </Card.Title>
                <Card.Text style={{ color: "gray", backgroundColor: "white" }}>
                  We are committed to giving back, supporting local initiatives,
                  and fostering a positive impact on communities through
                  sustainable practices.
                </Card.Text>
              </Card.Body>
            </Card>
          </CardGroup>

          <Container
            className="about-shankh-air"
            style={{ padding: "20px", width: "70%" }}
          >
            <Row>
              <Col>
                <h2 className="text-right">Why Shankh Air?</h2>
                <p className="text-right">
                  Global Presence: With an expansive network of destinations
                  across the globe, your journey with Shankh Air can take you to
                  exciting places, both professionally and personally.
                </p>
                <p className="text-right">
                  Innovation & Excellence: We are committed to shaping the
                  future of aviation by leveraging cutting-edge technology and
                  embracing a culture of innovation.
                </p>
                <p className="text-right">
                  Career Growth: We prioritize your personal and professional
                  development, offering a wide range of opportunities to learn,
                  grow, and advance in your career.
                </p>
                <p className="text-right">
                  Inclusive Culture: At Shankh Air, we believe in creating a
                  diverse and supportive environment where every individual is
                  valued and respected.
                </p>
              </Col>
            </Row>
          </Container>
          <ResumeForm></ResumeForm>
        </div>
      </div>
    </>
  );
};

export default Careers;
